<template>
  <div v-if="show" class="template-autocomplete" :style="positionStyle">
    <div class="autocomplete-header">
      <span class="text-muted small">Templates</span>
    </div>
    <div class="autocomplete-list">
      <div
        v-for="(template, index) in filteredTemplates"
        :key="template.id_whatsapp_template"
        :class="['autocomplete-item', { active: index === selectedIndex }]"
        @click="selectTemplate(template)"
        @mouseenter="selectedIndex = index"
      >
        <div class="template-name">{{ template.template_name }}</div>
        <div class="template-preview">{{ truncateContent(template.template_content) }}</div>
      </div>
      <div v-if="filteredTemplates.length === 0" class="autocomplete-empty">
        Nenhum template encontrado
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TemplateAutocomplete",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    templates: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: "",
    },
    position: {
      type: Object,
      default: () => ({ top: 0, left: 0 }),
    },
  },
  data() {
    return {
      selectedIndex: 0,
    };
  },
  computed: {
    filteredTemplates() {
      if (!this.searchQuery) {
        return this.templates.slice(0, 7);
      }
      const query = this.searchQuery.toLowerCase();
      return this.templates
        .filter(t => 
          t.template_name.toLowerCase().includes(query) ||
          t.template_content.toLowerCase().includes(query)
        )
        .slice(0, 7);
    },
    positionStyle() {
      return {
        top: `${this.position.top}px`,
        left: `${this.position.left}px`,
      };
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.selectedIndex = 0;
      }
    },
    filteredTemplates() {
      this.selectedIndex = 0;
    },
  },
  methods: {
    selectTemplate(template) {
      this.$emit("select", template);
    },
    truncateContent(content) {
      if (content.length > 60) {
        return content.substring(0, 60) + "...";
      }
      return content;
    },
    navigate(direction) {
      if (direction === "up") {
        this.selectedIndex = Math.max(0, this.selectedIndex - 1);
      } else if (direction === "down") {
        this.selectedIndex = Math.min(this.filteredTemplates.length - 1, this.selectedIndex + 1);
      }
    },
    selectCurrent() {
      if (this.filteredTemplates[this.selectedIndex]) {
        this.selectTemplate(this.filteredTemplates[this.selectedIndex]);
      }
    },
  },
};
</script>

<style scoped>
.template-autocomplete {
  position: fixed;
  z-index: 9999;
  background: white;
  border: 1px solid #e4e6ef;
  border-radius: 0.475rem;
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 400px;
  max-height: 400px;
  overflow: hidden;
}

.autocomplete-header {
  padding: 0.75rem 1rem;
  background-color: #f5f8fa;
  border-bottom: 1px solid #e4e6ef;
  font-weight: 600;
}

.autocomplete-list {
  max-height: 350px;
  overflow-y: auto;
}

.autocomplete-item {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f1f1f2;
  transition: background-color 0.2s;
}

.autocomplete-item:hover,
.autocomplete-item.active {
  background-color: #f5f8fa;
}

.template-name {
  font-weight: 600;
  color: #181c32;
  margin-bottom: 0.25rem;
}

.template-preview {
  font-size: 0.875rem;
  color: #7e8299;
  line-height: 1.4;
}

.autocomplete-empty {
  padding: 1rem;
  text-align: center;
  color: #7e8299;
  font-size: 0.875rem;
}
</style>

